import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class DataPermission extends DomainObject {
  id;
  name;
  descriptions;
  accessLevel = 'no_access';

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      descriptions: observable,
      accessLevel: observable
    });

    this.merge(other);
  }
}

export default DataPermission;
